import { ModelArrangement } from '../classes/model-arrangement.js';
import { generateScene } from '../GameTools.js';

export const appConfigBlock = ["$stateProvider","$urlRouterProvider","$controllerProvider","$compileProvider",
function( $stateProvider,  $urlRouterProvider,  $controllerProvider,  $compileProvider ) {

	angular.module ("gameApp" ).providers = {
		$compileProvider: $compileProvider
	};

	/**********/

	$controllerProvider.resolver( location.origin + "/model-preview/js/controllers/" );

	$stateProvider.state( "404", {
		templateUrl : "templates/view.404.html",
		controller  : [ "$rootScope", function( $rootScope ) {
			$rootScope.loading = false;
		}],
		url         : "/404?arrangement_uid&uid&mode",
	});

	$stateProvider.state("scene", {
		templateUrl : "src/js/components/game-scene-view/game-scene-view.template.html",
		controller  : "view.game-scene",
		url         : "/scene?arrangement_uid&uid&mode",
		resolve: {
			"ctrl": window.controllerResolver(["view.game-scene", "view.game-scene.oeuvres-panel", "view.game-scene.controls"]),
			"arrangement":
			        [ "$rootScope","Notification","gettextCatalog","ArrangementService","$q","$location","$state",
			function(  $rootScope,  Notification,  gettextCatalog,  ArrangementService,  $q,  $location,  $state ) {

				return $q.resolve().then( arrangement => {

					if (arrangement) return arrangement;

					if (window.____selected_arrangement) {

						arrangement = window.____selected_arrangement;

						try { delete window.____selected_arrangement; } catch(e) {}

						return arrangement;
					}
				
					if ($location.$$search.arrangement_uid) {

						return ArrangementService.getArrangement( $location.$$search.arrangement_uid )
							.then( ArrangementService.fillArrangement );
					}

					if (window.selected_lists) {

						arrangement = {
							lists: window.selected_lists.map(function(v){ return v.uid }),
							$oeuvres: {},
							version: 2
						};

						for (var i in window.selected_lists) {
							for (var e in window.selected_lists[i].$oeuvres) {
								arrangement.$oeuvres[ window.selected_lists[i].$oeuvres[e].uid ] = window.selected_lists[i].$oeuvres[e];
							}
						}
					}
						
					return arrangement;

				}).then(function( arrangement ){

					if (!arrangement) throw "Missing arrangement!";
						
					return ModelArrangement.fromJSON( arrangement ) || arrangement;

				}).catch(function( error ) {

					console.error( error );

					Notification.error( gettextCatalog.getString( "Failed to initiate the arrangement!" ));

					$rootScope.loading = false;

					try {
						$state.go( "arrangements" );
					} catch (err) {
						$state.go( "404" );
					}
				});

			}],
			"oeuvres":
			[        "ArrangementService","$location","Notification","arrangement","$oeuvresHandler",
			function( ArrangementService,  $location,  Notification,  arrangement,  $oeuvresHandler ){

				var lists = arrangement.lists = arrangement.lists || [];

				lists.sort(function( a, b ){ return a.localeCompare( b ); });

				arrangement.$lists_hash = lists.join("-");

				return $oeuvresHandler.init( arrangement.$oeuvres ).then(function( oeuvres ){
					return $rootScope.oeuvres = oeuvres;
				});

			}],
			"model":
			        ["$q","ArrangementService","$location","Notification","arrangement",
			function( $q,  ArrangementService,  $location,  Notification,  arrangement ){

				var model = arrangement.$model = arrangement.$model || window.____selected_model;
					
				try { delete window.____selected_model; } catch(e) {}

				return $q.when( buildModelConfig( model.$config, model )).then(function( config ){

					model.$config = config;

					return model;
				});

				/** Vähemmän yllättäen hyväksyy vaina attachment_uid/url -tyyppiset modelit */
				function buildModelConfig( config = {}, model = {} ) {

					if (!config.model_source) {

						config.model_source = "url";

						if ((model.config.default_source == null || model.config.default_source == "url") && model.config.default_url ){
							config.url = model.config.default_url;
						} else if ((model.config.default_source == null || model.config.default_source == "attachment") && model.config.attachment_uid ){
							config.url = "/ajax/attachments/"+ model.config.attachment_uid +".json";
						} else if (model.config.attachment_uid) {
							console.warn( "Dangerous assumption: model_source == attachment" );
							config.url = "/ajax/attachments/"+ model.config.attachment_uid +".json";
						} else throw new Error("?????");
					}

					config.type = model.config.type || "default";

					config.player = model.config.player || {};

					config.scene = config.scene || {};

					// Onko mallin skaalaa määrätty jotta se saadaan 1.0 / 1m -kokoiseksi?
					if (!config.model_scale) {
						var scale = parseFloat( model.config.scale );

						if (isFinite( scale ) && !isNaN( scale ) && scale > 0) {
							config.model_scale = scale;
						}
					}

					// @NOTE Muutettu nimeämiskäytäntö config.scale -> config.model_scale -m 31.5.2022
					config.scale = config.model_scale || null;

					return config;
				}
			}],
			"scene":
			        ["gameSceneService","$rootScope","$q","$state","$location","Notification","gettextCatalog","$playerHandler","model","oeuvres","arrangement","contextMenuService",
			function( gameSceneService,  $rootScope,  $q,  $state,  $location,  Notification,  gettextCatalog,  $playerHandler,  model,  oeuvres,  arrangement,  contextMenuService ){

//                if( arrangement.$config ) debugger;
                arrangement.$config = model.$config;

				return $playerHandler.init( model.$config.player )
				.then(async function() {
					try {
						let game_server_index = window.GAME_SERVER_INDEX;

						if (!game_server_index) {
							let _game_server_index = (location.search+"&").match(/[\?&]game_server_index=([^\?&]+)\&/)?.[1];
							if (_game_server_index) game_server_index = _game_server_index;
						}

						if (!game_server_index) {
							let gameserver = (location.search+"&").match(/[\?&]gameserver=([^\?&]+)\&/)?.[1];
							if (gameserver) game_server_index = gameserver + "/temu-peli.js";
						}

						if (game_server_index) {

							if (!(game_server_index + "/").match( /^https:\/\/((artest\.net)|((192\.168\.\d+\.\d+)|(localhost))(:\d+)?)\// )) {
								throw `Unsupported gameserver ${game_server_index}`;
							}

							await angular.element(document.body).injector().get("pluginsService").load( "game", (async () => {

								await (async function loadScript(scriptUrl) {
									return new Promise((resolve) => {
										const script = document.createElement('script');
										script.src = scriptUrl;
										script.type = "module";
										script.crossOrigin = "anonymous";
										script.onload = () => {
											resolve();
										};
										document.body.appendChild(script);
									});
								//})( game_server_index + "/temu-peli.js" );
								})( game_server_index );
							
								return (({ component, invoke }) => {
									console.log("temu-peli.js loaded", { component, invoke });
								});
							})())
						}
					} catch (error) {
						console.error( error );
					}

					return await generateScene( model.$config );
				})
				.then(function( scene ) {
					return gameSceneService.init( scene, arrangement );
				})
				.then(function() {
					try {
						return $q.when( $rootScope.__artestUserBar_ready.promise ).then(function() {

							if (window.MODEL_VIEWER || $location.$$search.mode == "walker" || !$User.logged) {

								$playerHandler.player.setMovementStrategy( "walker" );

							} else {
								gameSceneService.editor = true;
							}
						});
					} catch( error ) { console.error( error ); }
				})
				.then(function() {
					return gameSceneService.scene;
				})
				.catch(function( error ) {

                    console.error( error );

					Notification.error( gettextCatalog.getString( "Failed to initiate the scene!" ));

                    $rootScope.loading = false;

					$state.go( "arrangements", {
						arrangement_uid: $location.$$search.arrangement_uid
					});
				});
			}]
		}
	});
}];
